export const GOOGLE_REVIEWS_BRAND_NAME = 'Sunrun';

// Fallback copy for legacy entries that still toggle Google reviews via the
// `hasGoogleReviews` boolean and have not yet filled in `googleReviewsText`.
// Keeps existing pages from silently dropping the badge before editors migrate.
export const DEFAULT_GOOGLE_REVIEWS_TEXT = '10,000+ five-star reviews';
